// cspell: disable
import ImageChow from "./chow.png";
import ImageTammy from "./tammy.png";

export const quotes = [
  {
    companyName: "South China Morning Post",
    image: ImageTammy.src,
    name: "Tammy Tam / Publisher",
    quote: "“Unpack China’s complexity at a glance and shed light on opportunities”",
  },
  {
    companyName: "South China Morning Post",
    image: ImageChow.src,
    name: "Chow Chung-yan / Editor-in-Chief",
    quote: "“We can show the real picture of what’s going on in China - and what it means for you”",
  },
];
